<template>
  <div class="flex flex-col min-h-screen overflow-hidden supports-[overflow:clip]:overflow-clip">
    <HeaderSection />
    <section class="pt-16 md:pt-30 flex items-center justify-center bg-slate-900 mt-20 mb-16">
      <div class="max-w-lg w-full mx-auto text-center px-4 py-12 border border-[#55DAF7D1] rounded-2xl bg-slate-900/80 shadow-lg relative">
        <h1 class="text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-slate-50 to-cyan-200 mb-4">{{$t('notfound_title')}}</h1>
        <p class="text-lg text-slate-400 mb-8">{{$t('notfound_subtitle')}}</p>
        <router-link
          to="/"
          class="inline-flex items-center justify-center px-6 py-3 text-base font-semibold rounded-full bg-gradient-to-r from-cyan-500 to-green-300 text-slate-900 shadow transition duration-150 ease-in-out hover:from-cyan-400 hover:to-green-200 hover:text-black focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2"
        >
          {{$t('notfound_button')}}
        </router-link>
      </div>
    </section>
    <FooterSection />
  </div>
</template>

<script>
import HeaderSection from '@/partials/HeaderSection.vue'
import FooterSection from '@/partials/FooterSection.vue'
export default {
  name: 'NotFound',
  components: { HeaderSection, FooterSection }
}
</script>